<template>
  <div
    class="block-toggle-bar align-center justify-between"
    :class="{'show': value}"
    @click="$emit('input', !value)"
  >
    <div class="block-name align-center justify-center">
      <svg width="18px" height="18px" fill="var(--white-color)" fill-opacity="0.7">
        <use xlink:href="@/assets/images/sprite.svg#taxi"></use>
      </svg>
      <span class="ml-8">
        <slot />
      </span>
    </div>
    <svg width="8px" height="12px" fill="var(--white-color)" class="angle-icon">
      <use xlink:href="@/assets/images/sprite.svg#angle"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: "HeaderBlock",

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.block-toggle-bar {
  border-radius: 4px;
  background: var(--primary-color);
  padding: 12px 16px;
  cursor: pointer;
}

.show .block-toggle-bar {
  border-radius: 4px 4px 0 0;
}

.block-toggle-bar .block-name span {
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: var(--white-color);
}

.block-toggle-bar .angle-icon {
  transform: rotate(-90deg);
  transition: all 0.2s;
}

.block-toggle-bar.show .angle-icon {
  transform: rotate(90deg);
  transition: all 0.2s;
}
</style>
